import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';

// custom components
import Text from '../../atoms/text/index';
import Collapsable from '../collapsable';
import { Title  } from "@tremor/react";
import { Colors } from '../../../styles';

// nav
import { useLocation } from 'react-router-dom'


// styles
//import PRM_LIGHT_BLUE from '../../../styles/colors';

const CustomSidebar = (props) => {

    const location = useLocation();

    const [STATE, SETSTATE] = useState(false)

    const ListText = (props) => {

        const [mouseOver, setMouseOver] = useState(false)

        return (
            <Nav.Link
                onMouseOver={()=>{setMouseOver(true)}}
                onMouseLeave={()=>{setMouseOver(false)}}
                href={props.page}
                style={{
                    //opacity: mouseOver ? 1.0 : 0.8,
                    cursor: 'pointer',
                    borderLeft:'solid',
                    borderLeftColor: location.pathname == props.page ? Colors.PRM_LIGHT_BLUE : mouseOver ? '#7B7A7A' : '#A3A3A3',
                }}
            >
            <p
                style={{
                    fontSize:12,
                    marginLeft:4,
                    fontFamily:'Inter',
                    color: location.pathname == props.page ? Colors.PRM_LIGHT_BLUE : mouseOver ? '#7B7A7A' : '#A3A3A3'
                }}
            >{props.children}</p>
            </Nav.Link>
        )
    }

    return (
        <Row>
            <Col>
                <Container>

                    <Container className='mt-5' style={{ marginTop:6 }}>
                        <Text.Title color={'#307FE2'}>Overview</Text.Title>
                    </Container>

                    <Container>
                        <ListText page={'/introduction'}>Introduction</ListText>
                        <ListText page={'/getting-started'}>Getting Started</ListText>
                    </Container>

                    <Container className='mt-5' style={{ marginTop:6 }}>
                        <Text.Title color={'#307FE2'}>Integration</Text.Title>
                    </Container>

                    <Container>
                        <ListText page={'/authentication'}>Authentication</ListText>
                        <ListText page={'/create-booking'}>Create Booking</ListText>
                        <ListText page={'/getting-updated-deleted'}>Polling Bookings</ListText>
                        <ListText page={'/acknowledgement'}>Acknowledgements</ListText>
                        <ListText page={'/update-bookings'}>Update Bookings</ListText>
                        <ListText page={'/delete-bookings'}>Delete Bookings</ListText>
                    </Container>


                    <Container className='mt-5' style={{ marginTop:6 }}>
                        <Text.Title color={'#307FE2'}>Additional Services</Text.Title>
                    </Container>

                    <Container>
                        <ListText page={'/getting-a-booking'}>Get A Booking</ListText>
                        <ListText page={'/getting-bookings'}>Get Multiple Bookings</ListText>
                    </Container>

                </Container>
            </Col>
        </Row>
    );
};

export default CustomSidebar;
